import { useQuery } from '@tanstack/react-query';

import {
  getPublicTermsList,
  getRoleTerms,
  type TermsRole,
} from '@/services/public-terms';

const PUBLIC_TERMS_QUERY_KEY = 'public-terms';

export default function usePublicTermsList() {
  const query = useQuery({
    queryKey: [PUBLIC_TERMS_QUERY_KEY, 'list'],
    queryFn: getPublicTermsList,
  });

  return {
    items: query.data ?? [],
    isLoading: query.isPending,
    isError: query.isError,
    refetch: query.refetch,
  };
}

export function useRoleTerms({ type, slug }: TermsRole) {
  const query = useQuery({
    queryKey: [PUBLIC_TERMS_QUERY_KEY, 'role', type, slug ?? ''],
    queryFn: () => getRoleTerms({ type, slug }),
  });

  return {
    docs: query.data ?? [],
    isLoading: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
